import * as React from 'react';

import {LinkedEntity} from 'shells/linked-entity/linked-entity';

import type {EntityName} from '../types';

import styles from './changelog.module.css';

type Props = {
    entityName: EntityName;
    entityPageName: string;
    changeCount: number;
    isLoading: boolean;
};

export function ChangelogHeader(props: Props) {
    const countString = `${props.changeCount} ${
        props.changeCount === 1 ? 'update' : 'updates'
    } to `;

    const entity = (
        <div className={styles.entity}>
            <LinkedEntity
                name={props.entityPageName}
                type={translateEntityNameForLinkedEntity(props.entityName)}
                isLinkable={false}
            />
        </div>
    );

    return (
        <>
            <div className='flex justify-sb'>
                <div className={styles.title}>Changelog</div>
            </div>
            <div className='flex'>
                {props.isLoading ? 'Fetching updates to ' : countString}
                {entity}
            </div>
        </>
    );
}

const translateEntityNameForLinkedEntity = (entityName: EntityName) => {
    switch (entityName) {
        case 'Contacts':
            return 'contacts';
        case 'Accounts':
            return 'accounts';
        case 'Leads':
        default:
            return 'leads';
    }
};
